import type { Routes } from "@angular/router";
import { ENABLE_CHAT, SHOW_TALENT_POOL_UI } from "@ankaadia/ankaadia-shared";
import { environment } from "../../environments/environment";
import { GueteGemeinschaftLinkHandlingComponent } from "../organization-specific/guetegemeinschaft/gueteGemeinschaftLinkHandling.component";
import { NewUiGueteGemeinschaftLinkHandlingComponent } from "../organization-specific/guetegemeinschaft/new-ui-gueteGemeinschaftLinkHandling.component";
import { AccessDeniedComponent } from "../pages/access-denied/access-denied.component";
import { NewUiAccessDeniedComponent } from "../pages/access-denied/new-ui-access-denied.component";
import { ErrorComponent } from "../pages/error/error.component";
import { NewUiErrorComponent } from "../pages/error/new-ui-error.component";
import { KpiComponent } from "../pages/kpi/kpi.component";
import { NewUiKpiComponent } from "../pages/kpi/new-ui-kpi.component";
import { LoginDeniedComponent } from "../pages/login-denied/login-denied.component";
import { NewUiLoginDeniedComponent } from "../pages/login-denied/new-ui-login-denied.component";
import { LoginComponent } from "../pages/login/login.component";
import { NewUiLoginComponent } from "../pages/login/new-ui-login.component";
import { LogoutComponent } from "../pages/logout/logout.component";
import { NewUiLogoutComponent } from "../pages/logout/new-ui-logout.component";
import { NewUiNotFoundComponent } from "../pages/not-found/new-ui-not-found.component";
import { NotFoundComponent } from "../pages/not-found/not-found.component";
import { NewUiOrgSwitchComponent } from "../pages/org-switch/new-ui-org-switch.component";
import { OrgSwitchComponent } from "../pages/org-switch/org-switch.component";
import { NewUiProtectedshortLinkComponent } from "../pages/shortLink/new-ui-protectedshortLink.component";
import { NewUiShortLinkComponent } from "../pages/shortLink/new-ui-shortLink.component";
import { ProtectedShortLinkComponent } from "../pages/shortLink/protectedshortLink.component";
import { ShortLinkComponent } from "../pages/shortLink/shortLink.component";
import { TalentPoolDemoRedirectComponent } from "../pages/talent-pool-demo/talent-pool-demo-redirect.component";
import { NewUiTermsAndConditionsPageComponent } from "../pages/terms-and-conditions/new-ui-terms-and-conditions-page.component";
import { TermsAndConditionsPageComponent } from "../pages/terms-and-conditions/terms-and-conditions-page.component";
import { NewUiUnsubscribeComponent } from "../pages/unsubscribe/new-ui-unsubscribe.component";
import { UnsubscribeComponent } from "../pages/unsubscribe/unsubscribe.component";
import { PermissionGuard } from "../shared/guards/permission.guard";
import { Auth0CallbackComponent } from "./auth0Callback/auth0Callback.component";
import { NewUiAuth0CallbackComponent } from "./auth0Callback/new-ui-auth0Callback.component";
import { LandingComponent } from "./landing/landing.component";
import { NewUiLandingComponent } from "./landing/new-ui-landing.component";
import { MainComponent } from "./main/main.component";
import { NewUiMainComponent } from "./main/new-ui-main.component";

export const routes: Routes = [
  {
    path: "consent/:consentIdentifier/:organizationId/:consentGiverId",
    component: environment.newUI ? NewUiTermsAndConditionsPageComponent : TermsAndConditionsPageComponent,
  },
  {
    path: "consent/:organizationId/:consentGiverId",
    component: environment.newUI ? NewUiTermsAndConditionsPageComponent : TermsAndConditionsPageComponent,
  },
  { path: "notfound", component: environment.newUI ? NewUiNotFoundComponent : NotFoundComponent },
  { path: "accessdenied", component: environment.newUI ? NewUiAccessDeniedComponent : AccessDeniedComponent },
  { path: "logindenied", component: environment.newUI ? NewUiLoginDeniedComponent : LoginDeniedComponent },
  { path: "error", component: environment.newUI ? NewUiErrorComponent : ErrorComponent },
  { path: "login", component: environment.newUI ? NewUiLoginComponent : LoginComponent },
  { path: "logout", component: environment.newUI ? NewUiLogoutComponent : LogoutComponent },
  { path: "callback", component: environment.newUI ? NewUiAuth0CallbackComponent : Auth0CallbackComponent },
  {
    path: "guetegemeinschaft/recertification/:orgId",
    component: environment.newUI ? NewUiGueteGemeinschaftLinkHandlingComponent : GueteGemeinschaftLinkHandlingComponent,
    canActivate: [PermissionGuard],
  },
  {
    path: "guetegemeinschaft/recertification",
    component: environment.newUI ? NewUiGueteGemeinschaftLinkHandlingComponent : GueteGemeinschaftLinkHandlingComponent,
    canActivate: [PermissionGuard],
  },
  {
    path: "guetegemeinschaft/newRecertification",
    component: environment.newUI ? NewUiGueteGemeinschaftLinkHandlingComponent : GueteGemeinschaftLinkHandlingComponent,
  },
  {
    path: "switch/:orgId",
    component: environment.newUI ? NewUiOrgSwitchComponent : OrgSwitchComponent,
    canActivate: [PermissionGuard],
  },
  {
    path: "switch/:orgId/:href",
    component: environment.newUI ? NewUiOrgSwitchComponent : OrgSwitchComponent,
    canActivate: [PermissionGuard],
  },
  {
    path: "unsubscribe",
    component: environment.newUI ? NewUiUnsubscribeComponent : UnsubscribeComponent,
    canActivate: [PermissionGuard],
  },
  { path: "s/:hash", component: environment.newUI ? NewUiShortLinkComponent : ShortLinkComponent },
  {
    path: "p/:hash",
    component: environment.newUI ? NewUiProtectedshortLinkComponent : ProtectedShortLinkComponent,
    canActivate: [PermissionGuard],
  },
  ...(SHOW_TALENT_POOL_UI
    ? [
        {
          path: "talent-pool",
          loadChildren: () => import("../features/talent-pool/talent-pool-public.routes").then((m) => m.routes),
        },
      ]
    : []),
  {
    path: "candidate-application",
    loadChildren: () =>
      import("../features/candidate-application-mask/candidate-application-mask.routes").then((m) => m.routes),
  },
  { path: "kpi", component: environment.newUI ? NewUiKpiComponent : KpiComponent },
  {
    path: "talent-pool-demo",
    component: TalentPoolDemoRedirectComponent,
  },
  {
    path: "app",
    component: environment.newUI ? NewUiMainComponent : MainComponent,
    canActivate: [PermissionGuard],
    children: [
      {
        path: "",
        component: environment.newUI ? NewUiLandingComponent : LandingComponent,
        canActivate: [PermissionGuard],
      },
      {
        path: "candidates",
        loadChildren: () => import("../features/candidates/candidates.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "collections",
        loadChildren: () => import("../features/collections/collections.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "settings",
        children: [
          {
            path: "organizations",
            loadChildren: () => import("../features/organizations/organizations.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "user-groups",
            loadChildren: () => import("../features/user-groups/user-groups.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "users",
            loadChildren: () => import("../features/users/users.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "consent",
            loadChildren: () => import("../features/consent/consents.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "audit-definitions",
            loadChildren: () => import("../features/audit-definitions/audit-definitions.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "document-requirements",
            loadChildren: () =>
              import("../features/document-requirements/document-requirement.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "system",
            loadChildren: () => import("../features/organizations/organizations.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "candidate-profile-config",
            loadChildren: () =>
              import("../features/candidate-profile-config/candidate-profile-config.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "local-partner-profile-config",
            loadChildren: () =>
              import("../features/local-partner-profile-config/local-partner-profile-config.routes").then(
                (m) => m.routes
              ),
            canActivate: [PermissionGuard],
          },
          {
            path: "candidate-application-mask",
            loadChildren: () =>
              import("../features/candidate-application-mask-config/candidate-application-mask-config.routes").then(
                (m) => m.routes
              ),
            canActivate: [PermissionGuard],
          },
          {
            path: "vaccination-config",
            loadChildren: () =>
              import("../features/required-vaccinations/required-vaccinations.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "process-models",
            loadChildren: () => import("../features/process-models/process-models.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "professions",
            loadChildren: () => import("../features/profession/profession.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "ankaadia-tools",
            loadChildren: () => import("../features/ankaadia-tools/ankaadia-tools.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "icon-browser",
            loadChildren: () => import("../shared/icons/icon-browser.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "accounting",
            loadChildren: () => import("../features/accounting/accounting.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "plans",
            loadChildren: () => import("../features/plans/plans.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "professional-fields",
            loadChildren: () =>
              import("../features/professional-field/professional-field.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "sharing-presets",
            loadChildren: () => import("../features/sharing-preset/sharing-preset.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "online-applications",
            loadChildren: () =>
              import("../features/online-application/online-application.routes").then((m) => m.routes),
          },
          {
            path: "add-on-services",
            loadChildren: () => import("../features/add-on-services/add-on-services.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "api-config",
            loadChildren: () => import("../features/api-config/api-config.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          ...(ENABLE_CHAT
            ? [
                {
                  path: "chat",
                  loadChildren: () => import("../features/chat/chat.routes").then((m) => m.configRoutes),
                  canActivate: [PermissionGuard],
                },
              ]
            : []),
        ],
      },
      {
        path: "activity",
        loadChildren: () => import("../features/activity/activity.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "notifications",
        loadChildren: () => import("../features/notifications/notification.routes").then((m) => m.routes),
      },
      {
        path: "dashboard",
        loadChildren: () => import("../features/dashboard/dashboard.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "processes",
        loadChildren: () => import("../features/process/process.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "process-models",
        loadChildren: () => import("../features/process-models/process-models.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "process-actions",
        loadChildren: () => import("../features/process-actions/process-actions.routes").then((m) => m.routes),
      },
      {
        path: "email-send-out-rules",
        loadChildren: () =>
          import("../features/email-send-out-rules/email-send-out-rules.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "profile",
        loadChildren: () => import("../features/candidate-profile/candidate-profile.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "employers",
        loadChildren: () => import("../features/employer/employer.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "documents",
        loadChildren: () => import("../features/candidate-documents/candidate-documents.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "terms-and-conditions",
        loadChildren: () => import("../features/user-consent/user-consent.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "documents",
        loadChildren: () => import("../features/documents/documents.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "labor-agreements",
        loadChildren: () => import("../features/labor-agreements/labor-agreement.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "education",
        loadChildren: () => import("../features/education/education.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      ...(SHOW_TALENT_POOL_UI
        ? [
            {
              path: "talent-pools",
              loadChildren: () => import("../features/talent-pool/talent-pool.routes").then((m) => m.routes),
              canActivate: [PermissionGuard],
            },
          ]
        : []),
      ...(ENABLE_CHAT
        ? [
            {
              path: "chats",
              loadChildren: () => import("../features/chat/chat.routes").then((m) => m.routes),
              canActivate: [PermissionGuard],
            },
          ]
        : []),
      ...(environment.newUI
        ? [
            {
              path: "settings-menu",
              loadChildren: () => import("../features/settings-menu/new-ui-settings-menu.routes").then((m) => m.routes),
              canActivate: [PermissionGuard],
            },
          ]
        : []),
    ],
  },
  { path: "", redirectTo: "/app", pathMatch: "full" },
  { path: "**", redirectTo: "/notfound" },
];
